import { BrowserRouter as Router, Link } from "react-router-dom";
import { Helmet } from 'react-helmet'
import MyUrlmage from "./MyUrlmage";

let AlertShows;

function AlertShow() {
  if (AlertShows === "Yes") {
    return (
      <div className="alert alert-danger alert-dismissible fade show" role="alert">
        <strong>Website!</strong> You should enter at least 1 character with no <strong>#</strong>, <strong>%</strong> and <strong>/</strong>.
        <button type="button" className="close" data-dismiss="alert" aria-label="Close" style={{ outline: "none", border: "none" }}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    )
  }
}

function Home(props) {
  AlertShows = props.Alert
  return (
    <>
      <Router></Router>
      <Helmet><title>Deeptam Research Foundation - Home</title></Helmet>
      {AlertShow()}
      <div>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="mx-auto col-lg-6 col-md-6 align-items-center">
              <img
                src={`${MyUrlmage}/media/images/bg.jpg`}
                className="img-fluid"
                alt="..."
              />
            </div>
            <div className="text-center col-lg-6 col-md-6 container-fluid">
              <h1 style={{ fontSize: "26px" }}>Deeptam Research Foundation</h1>
              <p>
                <b>Me, a coding enthusiasts will teach you a lot of concepts of programming</b>
              </p>
              <Link
                to="/videos"
                className="inline-flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded text-lg btn-danger btn mb-3"
              >
                Start Learning
              </Link>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="card mx-auto my-2 p-2 align-items-center" style={{ width: '18rem' }}>
              <img src={`${MyUrlmage}/media/home.jpg`} class="padded card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title text-center">Home</h5>
                <p class="card-text text-center">Thinking where to started just Click on go to Home</p>
                <Link to="/" class="btn btn-primary d-block">Go to Home</Link>
              </div>
            </div>

            <div class="card mx-auto my-2 p-2 align-items-center" style={{ width: '18rem' }}>
              <img src={`${MyUrlmage}/media/programming.png`}
                class="padded card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title text-center">Programming Tutorials</h5>
                <p class="card-text text-center">Get and boost up your programming knowledge started with these
                  video
                  courses.</p>
                <Link to="/videos" class="btn btn-primary d-block">Go to Videos</Link>
              </div>
            </div>

            <div class="card mx-auto my-2 p-2 align-items-center" style={{ width: '18rem' }}>
              <img src={`${MyUrlmage}/media/contact-us.webp`}
                class="padded card-img-top" alt="..." />
              <div class="card-body">
                <h5 class="card-title text-center">Contact Us</h5>
                <p class="card-text text-center">Stuck at a problem. Feal free to contact with us and share the
                  problem with us. By just fill up the Contact Us form.</p>
                <Link to="/contact" class="btn btn-primary d-block">Contact Us</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
